import React from 'react';

import Helmet from '../components/Helmet';
import MainRouter from './MainRouter';
import ErrorBoundary from '../components/ErrorBoundary';
import ScrollToTop from '../components/ScrollToTop';


const AppLayout = () => (
  <ErrorBoundary>
    <Helmet defaultTitle>
      <title>Jobs Widget</title>
    </Helmet>
    <ScrollToTop>
      <MainRouter />
    </ScrollToTop>
  </ErrorBoundary>
);

export default AppLayout;
